import { IApplicationState } from '../../types/redux';

export const getIsOpen = (state: IApplicationState) => {
  return state.newQuestion.open;
};
